import { TP_Common } from './types'
import { useGetObjectsChildren } from '../../../../hooks/useGetObjectsChildren';
import { LoadingView } from '../../../../components';
import { FilteredAppsView } from '../../../components/FilteredAppsView';
import { FormattedMessage } from 'react-intl';
import { schema as schemaMultistate } from '../../../Devices/MultiState/types'
import { schema as schemaMultiStateSwitch } from '../../../Devices/MultiStateSwitch/types'
import { IAutomationObject } from '../../../types';
import { isParameterApp } from '../../../parameterApps';
import { isAnalogSensor } from '../../../Devices/SensorAnalog/types';
import { isDigitalSensor } from '../../../Devices/SensorDigital';

export function OperatorPanel(props: TP_Common) {
    const { children, isLoading, isSuccess, error } = useGetObjectsChildren(props.resourceGroupId, props.id)

    return (
        <LoadingView isLoading={isLoading} error={error} isSucess={isSuccess}>
             <FilteredAppsView header={<FormattedMessage id="P_CoolingHeating.PlantSwitch" defaultMessage={'Status'} />} apps={children ?? []} filter={msFilter}></FilteredAppsView>
             <FilteredAppsView header={<FormattedMessage id="Plant.DigitalSensors" defaultMessage={'Sensors'} />} apps={children ?? []} filter={digsensorFilter}></FilteredAppsView>
            <FilteredAppsView header={<FormattedMessage id="Plant.AnalogSensors" defaultMessage={'Measurments'} />} apps={children ?? []} filter={sensorFilter}></FilteredAppsView>
            
            <FilteredAppsView apps={children ?? []} filter={allTheRestFilter}></FilteredAppsView>
        </LoadingView>
    );
}

const digsensorFilter = (a: any) => {
    return  isDigitalSensor(a.schema)
}
const sensorFilter = (a: any) => {
    return  isAnalogSensor(a.schema)
}

const msFilter = (a: IAutomationObject) => {
    return a.schema === schemaMultistate || a.schema === schemaMultiStateSwitch;
}

const allTheRestFilter = (a: IAutomationObject) => {
    return !msFilter(a) && !sensorFilter(a) && !digsensorFilter(a)
        && !isParameterApp(a.schema);
}